import type {Mapper} from 'framework';
import type {MetricOverviewItem} from '../../domain/metric-overview-item';
import type {OverviewItemDto} from '../dto/body-measurements.dto';
import type {BodyMetricDtoToBodyMetricMapper} from './body-metric-dto-to-body-metric.mapper';
import type {MeasurementEntryDtoToMeasurementEntryMapper} from './measurement-entry-dto-to-measurement-entry.mapper';

export class OverviewItemDtoToMetricOverviewItemMapper implements Mapper<
  OverviewItemDto,
  MetricOverviewItem
> {
  constructor(
    private readonly metricMapper: BodyMetricDtoToBodyMetricMapper,
    private readonly entryMapper: MeasurementEntryDtoToMeasurementEntryMapper,
  ) {}

  transform(dto: OverviewItemDto): MetricOverviewItem {
    return {
      metric: this.metricMapper.transform(dto.metric),
      latest: dto.latest === null ? null : this.entryMapper.transform(dto.latest),
      previous: dto.previous === null ? null : this.entryMapper.transform(dto.previous),
    };
  }
}
